<template>
  <v-container>
    <h1>
      <v-icon class="iconHeader">mdi-archive</v-icon>
      {{ $t("views.shops.manage.header") }}
    </h1>
  </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>